import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59cb2880"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "workout-weather"
}
const _hoisted_2 = { class: "weather-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_4 = { class: "weather-th" }
const _hoisted_5 = ["src", "alt", "title"]
const _hoisted_6 = { class: "weather-th" }
const _hoisted_7 = ["src", "alt", "title"]
const _hoisted_8 = ["alt", "title"]
const _hoisted_9 = ["alt", "title"]
const _hoisted_10 = ["alt", "title"]

import { toRefs } from 'vue'

  import { IWorkoutObject } from '@/types/workouts'

  interface Props {
    workoutObject: IWorkoutObject
    useImperialUnits: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    workoutObject: null,
    useImperialUnits: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    workoutObject: IWorkoutObject
    useImperialUnits: boolean
  }

  

  const { useImperialUnits, workoutObject } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_Distance = _resolveComponent("Distance")!

  return (_unref(workoutObject).weatherStart && _unref(workoutObject).weatherEnd)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_3,
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$t('workouts.START')) + " ", 1),
                  _createElementVNode("img", {
                    class: "weather-img",
                    src: `/img/weather/${_unref(workoutObject).weatherStart.icon}.svg`,
                    alt: 
                  _ctx.$t(
                    `workouts.WEATHER.DARK_SKY.${_unref(workoutObject).weatherStart.icon}`
                  )
                ,
                    title: 
                  _ctx.$t(
                    `workouts.WEATHER.DARK_SKY.${_unref(workoutObject).weatherStart.icon}`
                  )
                
                  }, null, 8, _hoisted_5)
                ])
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t('workouts.END')) + " ", 1),
                  _createElementVNode("img", {
                    class: "weather-img",
                    src: `/img/weather/${_unref(workoutObject).weatherEnd.icon}.svg`,
                    alt: 
                  _ctx.$t(
                    `workouts.WEATHER.DARK_SKY.${_unref(workoutObject).weatherEnd.icon}`
                  )
                ,
                    title: 
                  _ctx.$t(
                    `workouts.WEATHER.DARK_SKY.${_unref(workoutObject).weatherEnd.icon}`
                  )
                
                  }, null, 8, _hoisted_7)
                ])
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("img", {
                  class: "weather-img weather-img-small",
                  src: "/img/weather/temperature.svg",
                  alt: _ctx.$t(`workouts.WEATHER.TEMPERATURE`),
                  title: _ctx.$t(`workouts.WEATHER.TEMPERATURE`)
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("td", null, _toDisplayString(Number(_unref(workoutObject).weatherStart.temperature).toFixed(1)) + "°C ", 1),
              _createElementVNode("td", null, _toDisplayString(Number(_unref(workoutObject).weatherEnd.temperature).toFixed(1)) + "°C ", 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("img", {
                  class: "weather-img weather-img-small",
                  src: "/img/weather/pour-rain.svg",
                  alt: _ctx.$t(`workouts.WEATHER.HUMIDITY`),
                  title: _ctx.$t(`workouts.WEATHER.HUMIDITY`)
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("td", null, _toDisplayString(Number(_unref(workoutObject).weatherStart.humidity * 100).toFixed(1)) + "% ", 1),
              _createElementVNode("td", null, _toDisplayString(Number(_unref(workoutObject).weatherEnd.humidity * 100).toFixed(1)) + "% ", 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("img", {
                  class: "weather-img weather-img-small",
                  src: "/img/weather/breeze.svg",
                  alt: _ctx.$t(`workouts.WEATHER.WIND`),
                  title: _ctx.$t(`workouts.WEATHER.WIND`)
                }, null, 8, _hoisted_10)
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_Distance, {
                  distance: _unref(workoutObject).weatherStart.wind,
                  unitFrom: "m",
                  digits: 1,
                  displayUnit: false,
                  useImperialUnits: _unref(useImperialUnits)
                }, null, 8, ["distance", "useImperialUnits"]),
                _createTextVNode(" " + _toDisplayString(_unref(useImperialUnits) ? 'ft' : 'm') + "/s ", 1)
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_Distance, {
                  distance: _unref(workoutObject).weatherEnd.wind,
                  unitFrom: "m",
                  digits: 1,
                  displayUnit: false,
                  useImperialUnits: _unref(useImperialUnits)
                }, null, 8, ["distance", "useImperialUnits"]),
                _createTextVNode(" " + _toDisplayString(_unref(useImperialUnits) ? 'ft' : 'm') + "/s ", 1)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})